import { Component, Element, h, Prop } from '@stencil/core';
import _ds from '../../../typescript/dot-stash';

declare global {
  interface Window {
    prestashop: any;
    $: any;
  }
}

export interface ProductBlockParams {
  id: string;
  attributeId: string;
  customizationId: string;
  hasVariants: boolean;
  fullSizeImage: string;
  name?: string;
  stock: number;
  packPrice?: number;
  packLabel?: string;
  capacity?: string;
  attributeGroupId?: string;
  isLogged?: boolean;
  displayPrices: boolean;
}

const defaultProductBlockParams = {
  id: '',
  attributeId: '',
  customizationId: '',
  hasVariants: false,
  fullSizeImage: '',
  stock: 0,
  isLogged: false,
  displayPrices: false,
}

@Component({
  tag: 'ds-product-block',
})
export class DSProductBlock {

  @Element() container: HTMLElement;

  @Prop() size: string = 'md';
  @Prop() params: string | ProductBlockParams = defaultProductBlockParams;

  productParams: ProductBlockParams;

  constructor() {
    this.addToCartButtonClickHandler = this.addToCartButtonClickHandler.bind(this);
  }

  componentWillLoad() {
    const paramsFromProp = _ds.props.fromJSON(this.params);
    const { name: productName, packPrice, isLogged } = paramsFromProp;
    const { 0: name, length: l, [l - 1]: capacity } = productName.split("-").map( string => string.trim() );
    const displayPrices = Boolean(packPrice) && isLogged;

    this.productParams = {
      ...paramsFromProp,
      name,
      capacity,
      displayPrices,
    }
  }
  
  componentDidLoad() {
    const productNameContainer = this.container.querySelector(".ds-product-block__description a");
    if (productNameContainer) {
      productNameContainer.innerHTML = this.productParams.name;
    }
  }

  async addToCartButtonClickHandler( event: Event ) {
    event.preventDefault();
    event.stopPropagation();

    if (this.productParams.isLogged) {
      let token = '';
      let cartUrl = '';
      const appComponent = document.querySelector("ds-page");
      if (appComponent) {
        ({ token, cartUrl } = appComponent);
      }
      const { id, customizationId } = this.productParams;
  
      const query = `quantity_wanted=1&id_product=${id}&token=${token}&id_customization=${customizationId}&add=1&action=update${this.productParams.attributeGroupId ? `&group[5]=${this.productParams.attributeGroupId}` : ''}`;
  
      try {
        const resp: any = await _ds.ajax.post(cartUrl, query);
        window.prestashop.emit('updateCart', {
          reason: {
            idProduct: resp.id_product,
            idProductAttribute: this.productParams.attributeId,
            idCustomization: resp.id_customization,
            linkAction: 'add-to-cart',
            cart: resp.cart,
          },
          resp,
        });
      } catch( err ) {
        window.prestashop.emit('handleError', {
          eventType: 'addProductToCart',
          err,
        });
      }
    }
  }

  render() {
    /* const { stock } = this.productParams; */
    
    return (
      <div
        class={{
          "ds-product-block": true,
          /* "--out-of-stock": stock === 0, */
          [`--${this.size}`]: true,
        }}
      >
        <div
          class="ds-product-block__image"
        >
          <slot name="image" />
          <div class="ds-product-block__actions">
            <slot name="actions" />
          </div>
        </div>
        
        <div class="ds-product-block__description">
          <slot />
        </div>
        
        <div class="ds-product-block__capacity">
          {this.productParams.capacity}
        </div>

        <div class="ds-product-block__price">
          {this.productParams.displayPrices && (
            <slot name="price" />
          )}
        </div>

        <div class="ds-product-block__pack-price">
          {this.productParams.displayPrices && (
            <ds-text mods="product-pack-price">
              {this.productParams.packLabel}: <strong>{this.productParams.packPrice.toString().padEnd(2,'0')} €</strong>
            </ds-text>
          )}
        </div>

        {((this.productParams.packPrice || 0) > 0 || !this.productParams.isLogged) && (
          <ds-button
            class="ds-product-block__quick-buy-button"
            type="button"
            mods={['sm', 'solid', 'primary', 'rounded']}
            onClick={ this.addToCartButtonClickHandler }
          >
            <slot name="button-label" />
          </ds-button>
        )}
        
        <div class="ds-product-block__reviews">
          <slot name="reviews" />
        </div>
      
      </div>
    );
  }
}